import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'infoContainer',
	`
		:lang(ar) {
			transform: scaleX(-1);
			direction: rtl;
		}
		width: 100%;
		padding: 50px 0;
		text-align: center;

		@media (max-width: 720px) {
			padding: 16px 0;
		}
	`
  ],
  [
    'wrapper',
    `
		display: inline-block;
		width: 600px;
		max-width: 90%;
		max-height: 100%;
		margin: 0 auto;
	`
  ],
  [
    'main',
    theme => `
		background-color: ${theme.color.text.white};
		padding: 40px 25px;
		border-radius: 6px;

		@media (max-width: 720px) {
			padding: 16px;
		}
	`
  ],
  [
    'header',
    `
		margin-bottom: 40px;
	`
  ],
  [
    'footer',
    `
		margin-top: 20px;
	`
  ]
]);
